import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { Pharmacy } from '@enums/pharmacies';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Hair Loss treatment type.
 */
export const HairLossTreatmentType = new TreatmentType({
  id: '19',
  name: ConsultationTreatmentTypes.HairLoss,
  designatedPharmacyId: Pharmacy.TAHA,
  genderSettings: new TreatmentGenderSettings({
    excludedForUpsells: {
      '/consultation/sexual-performance': Gender.Female,
    },
  }),
  requireHeightAndWeight: true,
  shippingService: 'USPS First-Class - 3-4 Days (Free)',
});
